import { ReactNode } from 'react';

// @mui material components
import { Theme } from '@mui/material/styles';

// Material Dashboard 2 PRO React TS components
import MDBox from '@components/MDBox';

// Declaring prop types for DataTableBodyCell
interface Props {
  children: ReactNode;
  noBorder?: boolean;
  align?: 'left' | 'right' | 'center';
  colspan?: number;
  border?: string;
  cleanPageTable?: boolean;
  width?: string;
}

function DataTableBodyCell({
  noBorder,
  align,
  children,
  colspan,
  border,
  width
}: Props): JSX.Element {
  return (
    <MDBox
      component='td'
      textAlign={align}
      py={1}
      px={3}
      sx={({ palette: { info }, typography: { size } }: Theme) => ({
        fontSize: size.sm,
        color: info.main,
        borderBottom: noBorder ? 'none' : `0.1px solid ${info.main}`
      })}
      colSpan={colspan}
      borderRight={border}
    >
      <MDBox
        display='inline-block'
        color='text'
        width={width || 'inherit'}
        sx={{
          verticalAlign: 'middle'
        }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Declaring default props for DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: 'left'
};

export default DataTableBodyCell;
